import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import './Forms.css';
import { ArrowLeft } from 'lucide-react';

const fields = [
  {
    id: 'fullName',
    label: 'Full Name',
    type: 'text',
    required: true,
    placeholder: 'Enter your full name'
  },
  {
    id: 'email',
    label: 'Email Address',
    type: 'email',
    required: true,
    placeholder: 'Enter your email address'
  },
  {
    id: 'phone',
    label: 'Phone Number',
    type: 'tel',
    required: true,
    placeholder: 'Enter your phone number'
  },
  {
    id: 'company',
    label: 'Company Name',
    type: 'text',
    required: true,
    placeholder: 'Enter your company name'
  },
  {
    id: 'linkedin',
    label: 'LinkedIn URL',
    type: 'url',
    required: true,
    placeholder: 'https://linkedin.com/in/yourprofile'
  },
  {
    id: 'instagram',
    label: 'Instagram Handle',
    type: 'text',
    required: true,
    placeholder: '@yourusername'
  },
  {
    id: 'message',
    label: 'Tell us about your goals',
    type: 'textarea',
    required: false,
    placeholder: 'What are you looking to achieve through this partnership?'
  }
];

function SponsorForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Add ResizeObserver error handler
  useEffect(() => {
    const resizeObserverError = error => {
      if (error.message.includes('ResizeObserver')) {
        const resizeObserverErrDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div'
        );
        const resizeObserverErr = document.getElementById(
          'webpack-dev-server-client-overlay'
        );
        if (resizeObserverErr) {
          resizeObserverErr.style.display = 'none';
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.style.display = 'none';
        }
      }
    };

    window.addEventListener('error', resizeObserverError);
    return () => {
      window.removeEventListener('error', resizeObserverError);
    };
  }, []);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      // Add timestamp to the submission
      const submissionData = {
        ...formData,
        type: 'sponsor',
        submittedAt: serverTimestamp(),
        status: 'new'
      };

      // Save to Firestore
      await addDoc(collection(db, 'submissions'), submissionData);
      
      // Immediately redirect to Instagram
      window.location.href = 'https://www.instagram.com/visiblewomenagency/';
    } catch (error) {
      console.error('Error submitting form:', error);
      setError('There was an error submitting your form. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-container events-form-container">
      <div className="form-page">
        <button onClick={() => navigate('/')} className="back-button">
          <ArrowLeft size={24} />
        </button>
        <h1 className="company-title">Visible Women Agency</h1>
        <img src="/v.png" alt="Visible Women Event" className="form-hero-image" />
        <div className="form-content">
          <h2 className="form-title">Work With Us</h2>
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} className="single-page-form">
            {fields.map((field) => (
              <div key={field.id} className="form-field">
                <label htmlFor={field.id} className="field-label">
                  {field.label}
                  {field.required && <span className="required">*</span>}
                </label>
                {field.type === 'textarea' ? (
                  <textarea
                    id={field.id}
                    name={field.id}
                    value={formData[field.id] || ''}
                    onChange={handleInputChange}
                    placeholder={field.placeholder}
                    required={field.required}
                    className="form-textarea"
                    rows={4}
                  />
                ) : (
                  <input
                    type={field.type}
                    id={field.id}
                    name={field.id}
                    value={formData[field.id] || ''}
                    onChange={handleInputChange}
                    placeholder={field.placeholder}
                    required={field.required}
                    className="form-input"
                  />
                )}
              </div>
            ))}
            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SponsorForm; 